export default __webpack_public_path__ + "static/media/CSUS_logo.374255b6.png";